import React from 'react'
import { config } from 'config'
import Helmet from 'react-helmet'
import LazyLoad from 'react-lazyload'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import ColorSquare from './ColorSquare'
import styled from 'styled-components'

const HomeBox = styled.div`
  display: flex;

  p {
    margin: 1rem;
  }

  @media (max-width: 620px) {
    flex-wrap: wrap;
    flex-direction: ${(props) => props.left ? 'column-reverse' : 'row'};

    p {
      margin: 1rem 0;
    }
  }

  .left {
    margin-left: 0;
  }
`

const Component = React.createClass({
  render: function() {
    return (
      <div>
        <h1>
          dasProject – Leben mit Beeinträchtigung
        </h1>

        <p>Menschen mit Behinderung sind wahrscheinlich nicht die ersten, an die man denkt, wenn über das Wort Schönheit oder Portraitfotografie gesprochen wird. Warum eigentlich nicht? Bestehende Klischees sind schlicht falsch und Vielseitigkeit ist die wahre Schönheit.</p>
        <h2>Was?</h2>

        <HomeBox>
          <ColorSquare imgId={'Screen_Shot_2017-03-28_at_18.35.36_hxqlja'} alt={'Ausschnitt von Alex'} color={'blue'} link={'/alex/'}/>
          <p>Bei dasProject wurde zuerst mit jedem_r zu Fotografierenden gemeinsam und individuell ein Shootingkonzept erstellt, welches die wichtigsten Punkte wie das Thema der Fotoserie, den Ort des Shootings, usw. behandelte.</p>
        </HomeBox>
        <HomeBox left>
          <p className="left">Basierend auf diesem Konzept wurden die Projektpartizipant_innen fotografiert und (noch k)ein Begleittext erstellt, der einerseits auf die Fotosujets eingeht, andererseits auf die Personen direkt und deren persönlichen Umgang mit dem Thema Behinderung.</p>
          <ColorSquare imgId={'Screen_Shot_2017-03-28_at_18.37.40_tyqg9m'} isEnd={true} alt={'Ausschnitt von Flo'} color={'orange'} link={'/flo/'}/>
        </HomeBox>
        <HomeBox>
          <ColorSquare imgId={'Screen_Shot_2017-03-28_at_18.39.19_bdhg4s'} alt={'Ausschnitt von Matthias'} color={'red'} link={'/matthias/'}/>
          <p>Um das dabei entstandene Bewusstsein zu verbreiten, wurde diese Plattform erstellt. <Link to={prefixLink('/alex/')} style={{color: 'inherit'}}>Hier geht's zu den ersten Fotos.</Link> </p>
        </HomeBox>
      </div>
    )
  }
})

export default Component



// WEBPACK FOOTER //
// ../components/HomeArticle.js